import React from 'react';
import Welcome from '../components/Welcome';
import WhyHere from '../components/WhyHere';
import DailyLife from './DailyLife';
import Comfort from '../components/Comfort';
import Arrival from '../components/Arrival';
import Services from '../components/Services';
import WhyUs from '../components/WhyUs';
import TalktoUs from '../components/TalkToUs';
import Concierge from '../components/Concierge';
import Destination from '../components/Destination';
import {path, _currentTimeStamp} from './Constant';
import parse from 'html-react-parser';
import { waitUntilElementExists } from '../components/Helper';
import { seo } from '../components/Seo';
import {
     Link
  } from "react-router-dom";
let $=window.$;
class Main extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: props.data,
            page:props.page,
            section:(typeof this.props.section != "undefined" && this.props.section != ''  ?this.props.section:'' ),
            currentTimeStamp:_currentTimeStamp()
        }
        this.location = window.location.href.substring(window.location.href.lastIndexOf('/') + 1);
        this.page = window.location.href.split('/')[window.location.href.split('/').length-2];
        this.page=(this.page == 'villa')?'main':this.page;
       
    }

    /**
     * 
     */
    componentDidMount =()=>{
        console.log(this.state.currentTimeStamp);
        let main = this;
         $(document).on('click','.side',function(e){
            //alert(main.page)
            if(main.page == 'main'){
                e.preventDefault();
               // console.log(e.target);
                var target = $(e.target.hash);
                target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top-50
                    }, 100);
                    return false;
                }
            }
            //main._initBookingForm();
         });
         if(this.state.section != ''){
            //alert(this.state.section)
             setTimeout(() => {
                $('#'+this.state.section+'-side').trigger('click');
               // this._initBookingForm();
             },900);
            
         }
         seo({
            title: this.props.data.result.seo_tags.seo_title,
            metaDescription: this.props.data.result.seo_tags.seo_description,
            metaKeywords: this.props.data.result.seo_tags.seo_keywords
        });
         this._initBookingForm();
    }

    componentDidUpdate(prevProps, prevState) {
        let { currentTimeStamp } = this.state;
        let selected_language = window.sessionStorage.getItem('language');
        let book_directly_widget_text = this.props.data.result.static_text.book_directly_widget_text;
        $('#note-text-'+selected_language).remove();
        $('<p id="note-text-'+selected_language+'" class="note-text">'+book_directly_widget_text+'</p>').insertAfter('#bookWidgetForm-'+currentTimeStamp+'-'+selected_language);
        
        //$('.book-size-md').text(this.props.data.result.static_text.book_now_text)
         
    }

    _initBookingForm = ()=>{
        let { currentTimeStamp } = this.state;
        if(this.state.data !=null && Object.keys(this.state.data).length > 0 && this.state.data.result.villa !=null ){
            if(this.state.data.result.villa.beds_24_villa_id !=null && this.state.data.result.villa.beds_24_villa_id !=''){
                 let propID=this.state.data.result.villa.beds_24_villa_id;
                  let languages = this.props.data.result.languages;
                    
                  setTimeout(() => {
                        languages.map((value,index)=>{
                            $('#bookWidget-'+currentTimeStamp+'-'+value).bookWidget({
                                propid:propID,
                                formAction:'https://beds24.com/booking.php',
                                widgetLang:value,
                                widgetType:'BookingBox'
                            });
                        });
                    }, 1200);
                waitUntilElementExists('.book-form-horizontal', (el) => {
                    let selected_language = window.sessionStorage.getItem('language');
                    let book_directly_widget_text = this.props.data.result.static_text.book_directly_widget_text;
                    let forms = $('.book-form-horizontal');
                    forms.each(function () {
                        let formLanguage = $(this).find('input[name="lang"]').val();
                        $(this)[0].setAttribute('id','bookWidgetForm-'+currentTimeStamp+'-'+formLanguage);
                        if(selected_language === formLanguage) {
                            $('<p id="note-text-'+formLanguage+'" class="note-text">'+book_directly_widget_text+'</p>').insertAfter('#bookWidgetForm-'+currentTimeStamp+'-'+formLanguage);
                        }
                        
                    });
                });
            }
        }
   }
    
    /**
     * 
     * @returns 
     */
    _getGetDiv=()=>{
        if(this.state.page == 'main'){
            return(
                <div className="col-6 pt-2 my-3 middle-section">
                <Welcome data={this.props.data.result.welcome} villa={this.props.data.result.villa} static_text={this.props.data.result.static_text}/>
                <hr />
                <WhyHere data={this.props.data.result.why_here} static_text={this.props.data.result.static_text} />
                <hr />
                <DailyLife data={this.props.data.result.daily_life} images={this.props.data.result.image} static_text={this.props.data.result.static_text} />
                <hr />
                <Comfort data={this.props.data.result.comfort} images={this.props.data.result.image} static_text={this.props.data.result.static_text} />
                <hr />
                <Arrival data={this.props.data.result.arrival} static_text={this.props.data.result.static_text} />
                <hr />
                <Services data={this.props.data.result.services} static_text={this.props.data.result.static_text} />
                </div>
            )
        }
        if(this.state.page == 'why-us'){
            return(
                <div className="col-6 pt-2 my-3 middle-section">
                <WhyUs data={this.props.data.result.why_us} static_text={this.props.data.result.static_text} />
                </div>
            )
        }
        if(this.state.page == 'concierge'){
            return(
                <div className="col-6 pt-2 my-3 middle-section">
                <Concierge data={this.props.data.result.concierge} static_text={this.props.data.result.static_text} />
                </div>
            )
        }
        if(this.state.page == 'destination'){
            return(
                <div className="col-6 pt-2 my-3 middle-section">
                <Destination data={this.props.data.result.destination} static_text={this.props.data.result.static_text} />
                </div>
            )
        }
        if(this.state.page == 'talk-to-us'){
            return(
                <div className="col-6 pt-2 my-3 middle-section">
                <TalktoUs data={this.props.data.result.contact_us} static_text={this.props.data.result.static_text} />
                </div>
            )
        }
     
        
    }

    _widgetDiv =() => {
        let { currentTimeStamp } = this.state;
        let languages = this.props.data.result.languages;
        const renderHTML = (rawHTML: string) => React.createElement("div", { dangerouslySetInnerHTML: { __html: rawHTML } });
        return languages.map((value,index)=> {
            if(value===this.props.data.result.villa.language) {
                return(
                <React.Fragment key={index}>
                    <div className="bookWidget-26284-97302-0-1618392968" id={'bookWidget-'+currentTimeStamp+'-'+value+''} style={{display:'block'}}>
                        <div id={'bookWidget-'+currentTimeStamp+'-'+value+''}></div>
                    </div>
                </React.Fragment>
            );
            } else {
                return(
                <React.Fragment key={index}>
                    <div className="bookWidget-26284-97302-0-1618392968" id={'bookWidget-'+currentTimeStamp+'-'+value+''} style={{display:'none'}}>
                        <div id={'bookWidget-'+currentTimeStamp+'-'+value+''}></div>
                    </div>
                </React.Fragment>
            );
            }
        })
    }

    /**
     * 
     * @returns 
     */
    render() {
        return (
            <React.Fragment>
                <main className="middle-area">
                    <section>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-3 collapse show blue-bg pt-2 pl-0" id="sidebar">
                                    <ul className="nav sticky-top">
                                        <li className="nav-item">
                                            {
                                                this.page == 'main'? <a className="nav-link side" id="welcome-area-side" href={this.page == 'main'?"#welcome-area":path+this.location}><img src={path+"images/icon1.png"} alt="Welcome" className="img-fluid d-block" /> {this.props.data.result.static_text.welcome_text}</a>
                                                :<Link className="nav-link side" id="welcome-area-side" to={{pathname:'/'+this.location,state:{'section':'welcome-area'}}}><img src={path+"images/icon1.png"} alt="Welcome" className="img-fluid d-block" /> {this.props.data.result.static_text.welcome_text}</Link>
                                            }
                                            {/* <a className="nav-link side" href={this.page == 'main'?"#welcome-area":path+this.location}><img src={path+"images/icon1.png"} alt="Welcome" className="img-fluid d-block" /> {this.props.data.result.static_text.welcome_text}</a> */}
                                        </li>
                                        <li className="nav-item">
                                            {
                                               this.page == 'main'? <a id="why-her-side" className="nav-link side" href={this.page == 'main'?"#why-her":path+this.location}><img src={path+"images/icon2.png"} alt="Why Here?" className="img-fluid d-block" /> {this.props.data.result.static_text.why_come_here_text}</a>
                                               :<Link className="nav-link side" id="why-her-side" to={{pathname:'/'+this.location,state:{'section':'why-her'}}} ><img src={path+"images/icon2.png"} alt="Why Here?" className="img-fluid d-block" /> {this.props.data.result.static_text.why_come_here_text}</Link>
                                      
                                            }
                                        </li>
                                        <li className="nav-item">
                                            {
                                                 this.page == 'main'? <a id="daily-life-side"  className="nav-link side" href={this.page == 'main'?"#daily-life":path+this.location}><img src={path+"images/icon3.png"} alt="Daily Life" className="img-fluid d-block" /> {this.props.data.result.static_text.daily_life_text}</a>
                                                 :<Link className="nav-link side" id="daily-life-side" to={{pathname:'/'+this.location,state:{'section':'daily-life'}}} ><img src={path+"images/icon3.png"} alt="Daily Life" className="img-fluid d-block" /> {this.props.data.result.static_text.daily_life_text}</Link>
                                        
                                            }
                                            {/* <a className="nav-link side" href={this.page == 'main'?"#daily-life":path+this.location}><img src={path+"images/icon3.png"} alt="Daily Life" className="img-fluid d-block" /> {this.props.data.result.static_text.daily_life_text}</a> */}
                                        </li>
                                        <li className="nav-item">
                                            {
                                                this.page == 'main'?<a id="comfort-side" className="nav-link side" href={this.page == 'main'?"#comfort":path+this.location}><img src={path+"images/icon4.png"} alt="Comfort" className="img-fluid d-block" /> {this.props.data.result.static_text.comfort_text}</a>
                                                :<Link className="nav-link side" id="comfort-side"  to={{pathname:'/'+this.location,state:{'section':'comfort'}}} ><img src={path+"images/icon4.png"} alt="Comfort" className="img-fluid d-block" /> {this.props.data.result.static_text.comfort_text}</Link>

                                            }
                                          {/* <a className="nav-link side" href={this.page == 'main'?"#comfort":path+this.location}><img src={path+"images/icon4.png"} alt="Comfort" className="img-fluid d-block" /> {this.props.data.result.static_text.comfort_text}</a> */}
                                        </li>
                                        <li className="nav-item">
                                            {
                                                this.page == 'main'?<a className="nav-link side" id="your-arrival-side"  href={this.page == 'main'?"#your-arrival":path+this.location}><img src={path+"images/icon5.png"} alt="Your arrival" className="img-fluid d-block" /> {this.props.data.result.static_text.your_arrival_text}</a>
                                                :<Link className="nav-link side" id="your-arrival-side" to={{pathname:'/'+this.location,state:{'section':'your-arrival'}}} ><img src={path+"images/icon5.png"} alt="Your arrival" className="img-fluid d-block" /> {this.props.data.result.static_text.your_arrival_text}</Link>

                                            }
                                            {/* <a className="nav-link side" href={this.page == 'main'?"#your-arrival":path+this.location}><img src={path+"images/icon5.png"} alt="Your arrival" className="img-fluid d-block" /> {this.props.data.result.static_text.your_arrival_text}</a> */}
                                        </li>
                                        <li className="nav-item">
                                           {
                                                this.page == 'main'?  <a id="services-side"  className="nav-link side" href={this.page == 'main'?"#services":path+this.location}><img src={path+"images/icon6.png"} alt="Services" className="img-fluid d-block" /> {this.props.data.result.static_text.services_text}</a>
                                                :<Link className="nav-link side" id="services-side"  to={{pathname:'/'+this.location,state:{'section':'services'}}} ><img src={path+"images/icon6.png"} alt="Services" className="img-fluid d-block" /> {this.props.data.result.static_text.services_text}</Link>

                                            }
                                            {/* <a className="nav-link side" href={this.page == 'main'?"#services":path+this.location}><img src={path+"images/icon6.png"} alt="Services" className="img-fluid d-block" /> {this.props.data.result.static_text.services_text}</a> */}
                                        </li>
                                    </ul>
                                </div>

                                {/* ---------------------------------------------------------- */}
                                {
                                  this._getGetDiv()
                                }
                                


                                {/* ---------------------------------------------------------------- */}

                                <div className="col-3 pt-2" id="right-area">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="rightBox" id="rightBox">
                                                {this._widgetDiv()}
                                                <div className="row mt-4">
                                                    <div className="col-md-6 col-6">
                                                        {
                                                            this.state.data.result.villa.airbnb_link != ''
                                                             ?
                                                             <a href={this.state.data.result.villa.airbnb_link != '' ?this.state.data.result.villa.airbnb_link:'' } target="_blank" ><img src={path+"images/airbnb.jpg"} className="img-fluid d-block" alt="Airbnb" /></a>
                                                             :
                                                             ''
                                                        }
                                                    </div>
                                                    {
                                                        this.state.data.result.villa.other_ota != "" && this.state.data.result.villa.other_ota =="Booking"
                                                         ?
                                                         <div className="col-md-6 col-6">
                                                         <a href={this.state.data.result.villa.other_link != '' ?this.state.data.result.villa.other_link:'' } target="_blank" ><img src={path+"images/booking-com.jpg"} className="img-fluid d-block ml-auto" alt="Booking Com" /></a>
                                                         </div>
                                                        :
                                                        ''
                                                    }
                                                     {
                                                        this.state.data.result.villa.other_ota != "" && this.state.data.result.villa.other_ota =="VRBO"
                                                         ?
                                                         <div className="col-md-6 col-6">
                                                         <a href={this.state.data.result.villa.other_link != '' ?this.state.data.result.villa.other_link:'' } target="_blank" ><img src={path+"images/vrbo.jpg"} className="img-fluid d-block ml-auto" alt="VRBO" /></a>
                                                         </div>
                                                        :
                                                        ''
                                                    }
                                                     {
                                                        this.state.data.result.villa.other_ota != "" && this.state.data.result.villa.other_ota =="Expedia"
                                                         ?
                                                         <div className="col-md-6 col-6">
                                                         <a href={this.state.data.result.villa.other_link != '' ?this.state.data.result.villa.other_link:'' } target="_blank" ><img src={path+"images/expedia.png"} className="img-fluid d-block ml-auto" alt="Expedia" /></a>
                                                         </div>
                                                        :
                                                        ''
                                                    }
                                                    {
                                                        this.state.data.result.villa.other_ota != "" && this.state.data.result.villa.other_ota =="Agoda"
                                                         ?
                                                         <div className="col-md-6 col-6">
                                                         <a href={this.state.data.result.villa.other_link != '' ?this.state.data.result.villa.other_link:'' } target="_blank" ><img src={path+"images/agoda.png"} className="img-fluid d-block ml-auto" alt="Booking Com" /></a>
                                                         </div>
                                                        :
                                                        ''
                                                    }
                                                   
                                                    {/* <button type="button" className="btn"></button> */}
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <h5 className="text-center my-3">{this.props.data.result.static_text.full_disclosure_text}</h5>
                                                        <div>{parse(this.props.data.result.welcome.disclosure_text)}</div>
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
                    {/* ---------------------------------------------------------------- */}

                    

                    {/* ---------------------------------------------------------------- */}
            </React.Fragment>
        );
    }
}

export default Main;